import React from 'react';
import Paper from 'material-ui/Paper';
import Avatar from 'material-ui/Avatar';

import styles from './styles/LoginFormBoxStyles';

const LoginFormBox = ({title, logo}) => {
    return (
        <Paper style={styles.container} >
            <span style={styles.iconSpan}>
                <Avatar src={logo} style={styles.icon} />
            </span>

            <div style={styles.content}>
                <h6 style={styles.text}>{title}</h6>
            </div>
        </Paper>
    );
};

export default LoginFormBox;


// WEBPACK FOOTER //
// ./src/components/login/LoginFormBox.js